<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              2024 Veritas Crew and Family Parties - Iloilo and Bacolod
            </h2>
            <p class="vmc-text-primary-2 letter-spacing-1 mb-0">
              By Veritas Admin — December 01, 2024
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center pt-4">
            <p class="my-3 text-left">
              Veritas Maritime Corporation held its annual Crew and Family Parties, in advance celebration of the holiday season, across several Provincial Chapters.  Activities commenced from November 8 to 10, 2024 in Iloilo and Bacolod.
            </p>
            <p class="text-left my-3">
              Events in Iloilo kicked off with the CSR activity last November 8, as Veritas hosted a feeding program and gift giving to 210 less fortunate kids in the community. Our delegation was greeted with a special dance number from the pre-school children, followed by other fun activities during the day.  All delegates from Veritas and our Principals were present.
            </p>

            <p class="text-left my-3">
              This was then followed with the Iloilo Party last November 9 at Grand Xing Imperial Hotel, and Bacolod Party last November 10 at L’Fisher Hotel.  Both allottee chapters having the largest attendance, Iloilo with 674 attendees (63 crew/210 allottees/401 family and guests) and 616 for Bacolod (41 crew/190 allottees/385 family and guests). We again had full participation of our Principals, representing KRBS with KRBS-KOBE Crewing Group Mr. Ryosuke Tamura, Managing Executive Officer Capt. Makoto Kono, and KRBS-ROHQ OCHG Mr. Jun Ragos, and from KSK, Senior Managing Director Mr. Toshihiro Kato, and Managing Director Mr. Akihiro Nishi.
            </p>

            <p class="text-left my-3">
              In all allottee parties, message of encouragement and thanks were given by our Principals, with the highlight of the programs focused in honoring our long serving crew, as led and recognized by our President Mr. Jiro Marquez and Chairman Mr. Ericson Marquez, with the management team. Exciting games and raffle prizes were given throughout the programs.  Special performances were also presented by both Allottee/Crew Families to everyone’s enjoyment.
            </p>

            <div class="d-flex justify-content-center flex-wrap">
              <div class="m-1">
                <img :src="section1" alt="" class="border pl-1" style="height: auto; width: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VmcCrewFamilyParty2024IloiloBacolod",
  data(){
    return {
      section1 : require(`@/assets/news/2024/IloiloBacolod2024.jpg`)
    }
  }
}
</script>

<style scoped>

</style>
